import moment from 'moment';

export function JsonParseIfValid<T>(value: string): T | null {
  try {
    return JSON.parse(value) as T;
  } catch {
    return null;
  }
}

export function calculateExpiryDate(expiresInSeconds: number): string {
  const expiresAt = moment()
    .add(expiresInSeconds, 'second');
  return JSON.stringify(expiresAt.valueOf());
}
